<div class="container c-section__wrapper">
  <div>
    <ls-section>
      <ls-cr-description title="This is the title for the description">
        For QA: the padding or margins to the left and the right aren't part of
        the description component. The container that uses the description
        component will be responsible for this. To get this "fully" working we
        will need to change our side-bar behaviour as well, the dimension don't
        align fully.
      </ls-cr-description>
      <ls-cr-card>
        <card-body>
          Card with input
          <ls-cr-field-wrapper
            [id]="'simple3'"
            label="Label"
            prefix="$"
            suffix="*"
          >
            <input cr-input type="number" placeholder="Placeholder" />
          </ls-cr-field-wrapper>
        </card-body>
        <card-footer>And a footer</card-footer>
      </ls-cr-card>
    </ls-section>

    <ls-section>
      <ls-cr-description title="This is a copy"></ls-cr-description>
      <ls-cr-card>
        <card-body>
          Card with only body
        </card-body>
      </ls-cr-card>
    </ls-section>
  </div>

  <div class="card">
    <p ls-heading1>This is the Card Component:</p>

    <ls-cr-card>
      <card-header>
        <p ls-heading1>Before you QA</p>
        <p ls-body>This is the title</p>
      </card-header>

      <card-body>
        <p ls-body>
          To get a "real" look and feel, you will need to set the font-size of
          the page correctly. Currently the font-size is 14px but you will have
          to enlarge it to 16px
        </p>
        <p ls-body>
          You can do this by clicking Right Mouse button > inspect element. Then
          on the top find the HTML tag and change the fontsize
        </p>
      </card-body>

      <card-footer ls-body>This is the footer </card-footer>
    </ls-cr-card>

    <br />

    <ls-cr-card>
      <card-body>Card with only body</card-body>
    </ls-cr-card>

    <br />

    <ls-cr-card>
      <card-body>Card with body</card-body>
      <card-footer>and footer</card-footer>
    </ls-cr-card>
  </div>

  <ls-cr-divider></ls-cr-divider>

  <div class="text">
    <p ls-heading1>These are the text components:</p>
    <br />
    <div>
      <p ls-bold>This is bold</p>
      <p ls-dimmed>This is dimmed</p>
      <p ls-heading1 ls-bold>This is heading 1 bold</p>
      <p ls-heading1 ls-dimmed>This is heading 1 dimmed</p>
      <p ls-dimmed ls-bodySmall>This is a dimmed small body</p>
    </div>
    <div>
      <a ls-link href="www.google.com">This is a link </a>
    </div>

    <div>
      <a href="www.google.com" ls-bold ls-link>This is a bold link </a>
    </div>
  </div>

  <ls-cr-divider [dotted]="true"></ls-cr-divider>

  <div class="inputs">
    <form [formGroup]="form" autocomplete="off">
      <div class="simple">
        <p ls-heading1>These are the form Elements:</p>

        <div>
          <ls-cr-field-wrapper [id]="'simple1'" label="Label no placeholder">
            <input
              formControlName="simple1"
              cr-input
              type="text"
              id="simple1"
            />
          </ls-cr-field-wrapper>
        </div>

        <div>
          <ls-cr-field-wrapper [id]="'simple2'" label="Label">
            <input
              formControlName="simple2"
              cr-input
              type="email"
              id="simple2"
              placeholder="Placeholder text"
            />
          </ls-cr-field-wrapper>
        </div>

        <div>
          <ls-cr-field-wrapper
            [id]="'simple3'"
            label="Label"
            description="Description text"
            prefix="$"
            suffix="*"
            textHelper="Text helper"
            labelHelper="Plain text helper"
          >
            <input
              formControlName="simple3"
              cr-input
              type="number"
              id="simple3"
              placeholder="Placeholder"
            />
          </ls-cr-field-wrapper>
        </div>

        <div>
          <ls-cr-field-wrapper
            [id]="'simple4'"
            label="A password field"
            description="Description text"
            textHelper="Text helper"
            labelHelper="Plain text helper"
          >
            <input
              formControlName="simple4"
              cr-input
              type="password"
              id="simple4"
              placeholder="Placeholder"
            />
          </ls-cr-field-wrapper>
        </div>

        <div>
          <ls-cr-field-wrapper
            [id]="'simple5'"
            label="Date (will not work in Safari)"
            description="Description text"
            prefix="$"
            suffix="*"
            textHelper="Text helper"
          >
            <span
              *labelHelper
              class="cr-input__text-helper--warning cr-badge cr-badge--info cr-badge--small"
            >
              As an element
            </span>

            <input
              formControlName="simple5"
              cr-input
              type="date"
              id="simple5"
              placeholder="Placeholder"
            />
          </ls-cr-field-wrapper>
        </div>

        <div>
          <ls-cr-field-wrapper
            [id]="'blah'"
            label="With prefix and suffix as elements"
          >
            <i *inputPrefix class="fa fa-exclamation-circle"></i>
            <input
              formControlName="simple6"
              cr-input
              type="text"
              id="simple6"
              placeholder="Placeholder"
            />

            <i *inputSuffix class="fa fa-check-circle"></i>
          </ls-cr-field-wrapper>
        </div>

        <div>
          <ls-cr-field-wrapper
            [id]="'simple7'"
            label="With prefix and suffix as elements"
            [textHelper]="
              form.controls.simple7.errors?.minlength
                ? 'Min Length should be 12'
                : null
            "
            [status]="form.controls.simple7.errors ? 'error' : null"
          >
            <input
              formControlName="simple7"
              cr-input
              type="text"
              id="simple7"
              placeholder="Placeholder"
            />
            <ng-container *ngIf="form.controls.simple7.errors">
              <i *inputSuffix class="fa fa-exclamation-circle"></i>
            </ng-container>
          </ls-cr-field-wrapper>
        </div>

        <div>
          <ls-cr-field-wrapper [id]="'simple8'" label="Disabled thingy">
            <input
              formControlName="simple8"
              cr-input
              type="text"
              id="simple8"
              placeholder="Placeholder"
            />
          </ls-cr-field-wrapper>
        </div>

        <div>
          <ls-cr-field-wrapper [id]="'simple9'" label="Disabled thingy">
            <textarea
              formControlName="simple9"
              cr-input
              type="text"
              id="simple9"
              placeholder="Placeholder"
            ></textarea>
          </ls-cr-field-wrapper>
        </div>
      </div>
    </form>
  </div>

  <ls-cr-divider></ls-cr-divider>

  <div class="description">
    <p ls-heading1>This is a description component:</p>
    <br />
    <ls-cr-card>
      <card-body>
        <ls-cr-description title="This is the title">
          <p ls-body>This is the description</p>
          <p ls-bodySmall>This is the description but smaller</p>
        </ls-cr-description>
      </card-body>
    </ls-cr-card>
  </div>

  <div class="qa">
    <div>
      <div class="row">
        <button ls-cr-button>Default</button>
        <button ls-cr-button variant="primary">Primary</button>
        <button ls-cr-button variant="secondary">Secondary</button>
        <button ls-cr-button variant="danger">Danger</button>
      </div>

      <div class="row">
        <button ls-cr-button variant="primary" buttonType="fill">
          Primary Fill
        </button>
        <button ls-cr-button variant="secondary" buttonType="fill">
          Secondary Fill
        </button>
        <button ls-cr-button variant="danger" buttonType="fill">
          Danger Fill
        </button>
      </div>

      <div class="row">
        <button ls-cr-button size="small">Small</button>
        <button ls-cr-button variant="primary">Medium</button>
        <button ls-cr-button variant="secondary" size="large">Large</button>
        <button ls-cr-button variant="danger" size="xlarge">Extra-Large</button>
      </div>

      <div class="row vertical">
        <button ls-cr-button size="small" block="true">Small Block</button>
        <button ls-cr-button variant="primary" block="true">
          Medium Block
        </button>
        <button ls-cr-button variant="secondary" size="large" block="true">
          Large Block
        </button>
        <button ls-cr-button variant="danger" size="xlarge" block="true">
          Extra-Large Block
        </button>
      </div>

      <div class="row">
        <a ls-cr-button size="small" href="https://google.com">Link</a>
        <a ls-cr-button variant="primary" href="https://google.com">Link</a>
        <a
          ls-cr-button
          variant="secondary"
          size="large"
          href="https://google.com"
          >Link</a
        >
        <a ls-cr-button variant="danger" size="xlarge" href="https://google.com"
          >Link</a
        >
      </div>

      <div class="row">
        <button ls-cr-button size="small" buttonType="fill" disabled="true">
          Disabled Small
        </button>
        <button
          ls-cr-button
          variant="primary"
          buttonType="fill"
          disabled="true"
        >
          Disabled Medium
        </button>
        <button
          ls-cr-button
          variant="secondary"
          size="large"
          buttonType="fill"
          disabled="true"
        >
          Disabled Large
        </button>
        <button
          ls-cr-button
          variant="danger"
          size="xlarge"
          buttonType="fill"
          disabled="true"
        >
          Disabled Extra-Large
        </button>
      </div>

      <div class="row">
        <button ls-cr-button loading="true">Default</button>
        <button ls-cr-button variant="primary" loading="true">Primary</button>
        <button ls-cr-button variant="secondary" loading="true">
          Secondary
        </button>
        <button ls-cr-button variant="danger" loading="true">Danger</button>
      </div>

      <div class="row">
        <button ls-cr-button size="small" buttonType="fill" loading="true">
          Small
        </button>
        <button ls-cr-button variant="primary" buttonType="fill" loading="true">
          Medium
        </button>
        <button
          ls-cr-button
          variant="secondary"
          size="large"
          buttonType="fill"
          loading="true"
        >
          Large
        </button>
        <button
          ls-cr-button
          variant="danger"
          size="xlarge"
          buttonType="fill"
          loading="true"
        >
          Extra-Large
        </button>
      </div>
    </div>
  </div>
</div>
